var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
// import AdditionalJobsComponent from './taskDetailAccordians/revisedEstimateAdditionalJobs'
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AlternatePartConfigUrl, ByRevisedEstimateCreateUrl, EstimateJobCountUrl, RevisedEstimateCreateUrl, RevisedEstimateIsExistUrl, jobCardGetDetailAPI } from '../../../api/url';
import { ArrowLeftIconNew } from '../../../assets/images';
import { MuiBorderBottom, MuiStack } from '../../../components';
import CustomeAccordianWithButton from '../../../components/atoms/customAccordianWithButton';
import { MuiIconButton } from '../../../components/atoms/iconButtonComponent';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import SkeletonLoader from '../../../components/atoms/sketeton';
import { EModuleSection, EParentModuleName, ESectionAttributeValue, ESystemName, ETaskName, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { setUpdatedModuleSectionByChannel, showLoader } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, resetState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import { getAlternatePartConfigByTaskName, scrollToTop } from '../../../utils/utils';
import RevisedEstimatePeriodicMaintainanceComponent from './revisedEstimate.periodicParts';
import { RevisedEstimateAdditionalJobsComponent } from './taskDetailAccordians/revisedEstimateAdditionalJobs';
import RevisedEstimateStandaredJobsComponent from './taskDetailAccordians/revisedEstimateStandardJobs';
// import AdditionalJobsComponent from '../../commonViews/taskDetails/taskDetailsCommonComponent/additionalJob/additionalJobComponent'
var AddNewJobs = function () {
    var trackButtonClick = useAnalyticsEventTracker("AddNewJobs");
    var _a = useSelector(function (state) { return state.crud; }), RevisedEstimateIsExist = _a.RevisedEstimateIsExist, upsertAdditionalItem = _a.upsertAdditionalItem;
    var _b = useSelector(function (state) { return state.common; }), updatedModuleSectionByChannel = _b.updatedModuleSectionByChannel, getSavedTaskDetailsCount = _b.getSavedTaskDetailsCount, tasksDetailsIsDisable = _b.tasksDetailsIsDisable, getTaskDetailsToggleValue = _b.getTaskDetailsToggleValue, isTaskDetailDataUpdated = _b.isTaskDetailDataUpdated, taskDetailDataSaved = _b.taskDetailDataSaved;
    var _c = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _c.ModuleDetailsGetById, documentDetailsGetById = _c.documentDetailsGetById, customerDetailsTrnalsteToJob = _c.customerDetailsTrnalsteToJob, TaskDetailsSectionSave = _c.TaskDetailsSectionSave, fuelIndicatorSaved = _c.fuelIndicatorSaved, JobCount = _c.JobCount;
    var _d = useState({
        "Additional Jobs": true,
        "Customer Voice": true,
        "Periodic Maintenance": true,
        "Standard Services": true
    }), alternatePartConfigState = _d[0], setAlternatePartConfigState = _d[1];
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _e = useParams(), id = _e.id, preJobCardDocumentId = _e.preJobCardDocumentId;
    var _f = useState(true), IsbtnDisabled = _f[0], setIsbtnDisabled = _f[1];
    var _g = useState(true), IsSavebtnDisabled = _g[0], setIsSavebtnDisabled = _g[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _h = useState({
        saveButtonStatus: false,
        generateButtonStatus: false,
        RevisedEstimateId: ''
    }), sendData = _h[0], setSendData = _h[1];
    var _j = useState(false), periodicMaintainanceApiCall = _j[0], setPeriodicMaintainanceApiCall = _j[1];
    var _k = useState(false), isExpanded = _k[0], setIsExpanded = _k[1];
    var _l = useState(false), expanded = _l[0], setExpanded = _l[1];
    var skeletonArray = Array.from({
        length: 4
    });
    var _m = useState(false), addiotionalJobApiCall = _m[0], setAddiotionalJobApiCall = _m[1];
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    useEffect(function () {
        scrollToTop();
        setTimeout(function () {
            getInitialData();
            getAlternatePartConfig();
        }, 0);
    }, [getTaskDetailsToggleValue]);
    var getInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray;
        return __generator(this, function (_a) {
            try {
                if (updatedModuleSectionByChannel.length == 0) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE);
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                        updatedList_1 = [];
                        data === null || data === void 0 || data.map(function (item) {
                            var newObj = Object.assign({}, item, item.Section);
                            delete newObj.Section;
                            updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                                isAccordianOpen: false
                            }));
                        });
                        obj_1 = {};
                        newArray_1 = [];
                        finalModuleSectionArray_1 = [];
                        res = updatedList_1.map(function (elem) {
                            var newSectionAttribute = elem.SectionAttributes;
                            var mergedObj = null;
                            var newAttribute = newSectionAttribute.map(function (el) {
                                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                    obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                    obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                    mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                                }
                            });
                            if (mergedObj) {
                                newArray_1.push(mergedObj);
                            }
                            obj_1 = {};
                            delete elem.SectionAttributes;
                            elem['SectionAttributes'] = [];
                            newArray_1.forEach(function (value) {
                                newSectionAttribute.forEach(function (value1) {
                                    if (value.id == value1.id) {
                                        elem.SectionAttributes.push(value);
                                    }
                                });
                            });
                            finalModuleSectionArray_1.push(elem);
                        });
                        sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        dispatch(setUpdatedModuleSectionByChannel(sortedArray));
                        // performAllButtonAction(sortedArray)
                        // getDisabled()
                    }
                }
            }
            catch (e) {
                console.log("Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getDocumentDetails();
        getCount();
        if (!preJobCardDocumentId || !(RevisedEstimateIsExist !== null && RevisedEstimateIsExist !== void 0 && RevisedEstimateIsExist.data)) {
            checkRevisedEstimateAPICall();
        }
    }, []);
    var checkRevisedEstimateAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestParams, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    requestParams = {
                        JobCardId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'RevisedEstimateIsExist',
                            url: RevisedEstimateIsExistUrl,
                            request: requestParams
                        }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpsertData = function () {
        if (preJobCardDocumentId && sendData.generateButtonStatus) {
            createByRevisedEstimate(sendData.RevisedEstimateId);
        }
        else if (!preJobCardDocumentId && sendData.generateButtonStatus && sendData.RevisedEstimateId) {
            createByRevisedEstimate(sendData.RevisedEstimateId);
        }
    };
    var createByRevisedEstimate = function (payloadRevisedEstimateId) { return __awaiter(void 0, void 0, void 0, function () {
        var _Response$payload, _Response$payload2, _Response$payload3, requestBody, Response, _Response$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        JobCardId: id,
                        RevisedEstimateId: payloadRevisedEstimateId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: ByRevisedEstimateCreateUrl,
                            request: requestBody
                        }))];
                case 1:
                    Response = _a.sent();
                    if ((Response === null || Response === void 0 || (_Response$payload = Response.payload) === null || _Response$payload === void 0 ? void 0 : _Response$payload.statusCode) == 201 && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && _Response$payload2.success && Response !== null && Response !== void 0 && (_Response$payload3 = Response.payload) !== null && _Response$payload3 !== void 0 && (_Response$payload3 = _Response$payload3.data) !== null && _Response$payload3 !== void 0 && _Response$payload3.PreJobCardDocumentId) {
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                        dispatch(resetState(["documentDetailsGetById"]));
                        navigate("/reviseEstimate-details/RevisedEstimate/".concat(Response === null || Response === void 0 || (_Response$payload4 = Response.payload) === null || _Response$payload4 === void 0 || (_Response$payload4 = _Response$payload4.data) === null || _Response$payload4 === void 0 ? void 0 : _Response$payload4.PreJobCardDocumentId, "/").concat(id));
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getAlternatePartConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, selectedBranch, request, result, _result$payload3, config, AdditionalJobsFlag, StandardServicesFlag, PeriodicMaintenanceFlag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
                    request = {
                        SystemName: EParentModuleName.RevisedServiceEstimate,
                        OrganizationId: selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: AlternatePartConfigUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        config = (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data;
                        AdditionalJobsFlag = getAlternatePartConfigByTaskName(ETaskName.AdditionalJobs, config);
                        StandardServicesFlag = getAlternatePartConfigByTaskName(ETaskName.StandardServices, config);
                        PeriodicMaintenanceFlag = getAlternatePartConfigByTaskName(ETaskName.PeriodicMaintenance, config);
                        setAlternatePartConfigState(_objectSpread(_objectSpread({}, alternatePartConfigState), {}, {
                            "Additional Jobs": AdditionalJobsFlag,
                            "Standard Services": StandardServicesFlag,
                            "Periodic Maintenance": PeriodicMaintenanceFlag
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDataFromChild = function (data) {
        setIsbtnDisabled(data);
    };
    var handleButtonStatus = function (data) {
        setIsSavebtnDisabled(data);
    };
    var handleHeaderBackClick = function () {
        navigate("/jobcard-details/".concat(id));
    };
    var getDocumentDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ModuleDetailsGetById',
                            url: jobCardGetDetailAPI(id),
                            request: {}
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getCount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'JobCount',
                            url: EstimateJobCountUrl,
                            request: {
                                EstimateId: preJobCardDocumentId
                            }
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var CreateRevisedEstimate = function (buttonName) { return __awaiter(void 0, void 0, void 0, function () {
        var _createRevisedEstimat, _createRevisedEstimat2, requestBody, createRevisedEstimateResponse, _createRevisedEstimat3, _createRevisedEstimat4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        JobCardId: id
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: RevisedEstimateCreateUrl,
                            request: requestBody
                        }))];
                case 1:
                    createRevisedEstimateResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat !== void 0 && _createRevisedEstimat.success && createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat2 = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat2 !== void 0 && (_createRevisedEstimat2 = _createRevisedEstimat2.data) !== null && _createRevisedEstimat2 !== void 0 && _createRevisedEstimat2.PreJobCardDocumentId) {
                        setSendData({
                            saveButtonStatus: true,
                            RevisedEstimateId: createRevisedEstimateResponse === null || createRevisedEstimateResponse === void 0 || (_createRevisedEstimat3 = createRevisedEstimateResponse.payload) === null || _createRevisedEstimat3 === void 0 || (_createRevisedEstimat3 = _createRevisedEstimat3.data) === null || _createRevisedEstimat3 === void 0 ? void 0 : _createRevisedEstimat3.PreJobCardDocumentId,
                            generateButtonStatus: buttonName === "GenerateEstimate" ? true : false
                        });
                        return [2 /*return*/, {
                                RevisedEstimateId: createRevisedEstimateResponse === null || createRevisedEstimateResponse === void 0 || (_createRevisedEstimat4 = createRevisedEstimateResponse.payload) === null || _createRevisedEstimat4 === void 0 || (_createRevisedEstimat4 = _createRevisedEstimat4.data) === null || _createRevisedEstimat4 === void 0 ? void 0 : _createRevisedEstimat4.PreJobCardDocumentId
                            }];
                    }
                    else {
                        return [2 /*return*/, ""];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var RevisedGenerateEstimateFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createdRevisedEstimateId;
        return __generator(this, function (_a) {
            createdRevisedEstimateId = "";
            navigate("/reviseEstimate-details/RevisedEstimate/".concat(preJobCardDocumentId, "/").concat(id));
            return [2 /*return*/];
        });
    }); };
    var handleGenerateEstimate = function () {
        trackButtonClick("ButtonClickEvent", "Genrate_Estimate_Click", undefined);
        RevisedGenerateEstimateFun();
    };
    var handleClicksave = function () {
        trackButtonClick("ButtonClickEvent", "SaveAs_Draft", undefined);
        if (preJobCardDocumentId) {
            setSendData({
                RevisedEstimateId: preJobCardDocumentId,
                saveButtonStatus: true,
                generateButtonStatus: false
            });
        }
        else {
            CreateRevisedEstimate("Save");
        }
    };
    var handleAccordianClick = function (value, key) {
        var updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) { return item.Key == key ? _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: value
        }) : _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: false
        }); });
        setIsExpanded(value);
        dispatch(setUpdatedModuleSectionByChannel(updatedList));
        setExpanded(!expanded);
    };
    var getAdditionalJobApiCall = function () {
        setAddiotionalJobApiCall(true);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "backArrowButton",
        onClick: handleHeaderBackClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowLeftIconNew,
        id: "backArrowIcon"
    })), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Add jobs")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiBorderBottom, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 8,
        paddingBottom: 12
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? /*#__PURE__*/ React.createElement(React.Fragment, null, updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.map(function (item) {
        var _item$SectionAttribut, _item$SectionAttribut2, _item$SectionAttribut3, _item$SectionAttribut4, _item$SectionAttribut5, _item$SectionAttribut6;
        return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut = item.SectionAttributes[0]) !== null && _item$SectionAttribut !== void 0 && _item$SectionAttribut.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 8px 8px 8px"
        }, item === null || item === void 0 || (_item$SectionAttribut2 = item.SectionAttributes) === null || _item$SectionAttribut2 === void 0 ? void 0 : _item$SectionAttribut2.map(function (elem, accordianIndex) {
            var _JobCount$data, _JobCount$data2;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                title: elem !== null && elem !== void 0 && elem.MANDATORY && Module === isModuleConfig.Bajaj ? "".concat(item === null || item === void 0 ? void 0 : item.DisplayName, " *") : item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key)
                // switchButtonsEnabled={allswitchEnabled || elem?.MANDATORY && elem?.MANDATORYDefaultValue || elem?.DISABLED && elem?.DISABLEDDefaultValue}
                ,
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    setPeriodicMaintainanceApiCall(true);
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.PeriodicMaintenance); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.periodicMaintenanceToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: JobCount === null || JobCount === void 0 || (_JobCount$data = JobCount.data) === null || _JobCount$data === void 0 ? void 0 : _JobCount$data.PeriodicParts,
                countVisible: true,
                declinejobCountVisible: false,
                declineJobLength: JobCount === null || JobCount === void 0 || (_JobCount$data2 = JobCount.data) === null || _JobCount$data2 === void 0 ? void 0 : _JobCount$data2.CustomerDeclinedJobs,
                hideSwitch: true
            }, /*#__PURE__*/ React.createElement(RevisedEstimatePeriodicMaintainanceComponent, {
                parentModuleName: EParentModuleName.RevisedServiceEstimate
                // getSavedPeriodicPartsUrl={getEstimatePeriodicPartUrl}
                ,
                jobCardId: id,
                RevisedEstimateId: preJobCardDocumentId,
                callApIStatus: periodicMaintainanceApiCall,
                isSaveButton: true
                // isDisabled={props.isDisabled}
                ,
                SystemName: ESystemName.Estimate,
                alternatePartConfigState: alternatePartConfigState
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.StandardJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut3 = item.SectionAttributes[0]) !== null && _item$SectionAttribut3 !== void 0 && _item$SectionAttribut3.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 8px 8px 8px"
        }, item === null || item === void 0 || (_item$SectionAttribut4 = item.SectionAttributes) === null || _item$SectionAttribut4 === void 0 ? void 0 : _item$SectionAttribut4.map(function (elem, accordianIndex) {
            var _JobCount$data3;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                title: elem !== null && elem !== void 0 && elem.MANDATORY && Module === isModuleConfig.Bajaj ? "".concat(item === null || item === void 0 ? void 0 : item.DisplayName, " *") : item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: false || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    // getStandaredJobApiCall()
                    // checkPerformAll()
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.StandardJobs); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.standardJobsToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: JobCount === null || JobCount === void 0 || (_JobCount$data3 = JobCount.data) === null || _JobCount$data3 === void 0 ? void 0 : _JobCount$data3.StandardParts,
                countVisible: true,
                hideSwitch: true
            }, /*#__PURE__*/ React.createElement(RevisedEstimateStandaredJobsComponent, {
                parentModuleName: EParentModuleName.ServiceEstimate,
                SaveStandaredJobUrl: '',
                getSavedStandaredJobUrl: '',
                callApIStatus: true,
                isSaveButton: false,
                isDisabled: false,
                handleDataFromChild: handleDataFromChild,
                alternatePartConfigState: alternatePartConfigState
            }))
                // <>Standard Jobs</>
                : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdditionalJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut5 = item.SectionAttributes[0]) !== null && _item$SectionAttribut5 !== void 0 && _item$SectionAttribut5.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 8px 8px 8px"
        }, item === null || item === void 0 || (_item$SectionAttribut6 = item.SectionAttributes) === null || _item$SectionAttribut6 === void 0 ? void 0 : _item$SectionAttribut6.map(function (elem, accordianIndex) {
            var _JobCount$data4;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                title: elem !== null && elem !== void 0 && elem.MANDATORY && Module === isModuleConfig.Bajaj ? "".concat(item === null || item === void 0 ? void 0 : item.DisplayName, " *") : item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key)
                // switchButtonsEnabled={allswitchEnabled || elem?.MANDATORY && elem?.MANDATORYDefaultValue || elem?.DISABLED && elem?.DISABLEDDefaultValue || additionalJobAdded}
                // switchButtonsEnabled={true} 
                ,
                switchButtonsEnabled: false || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    getAdditionalJobApiCall();
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.AdditionalJobs); }
                // selected={elem?.OPTIONALDefaultValue || getTaskDetailsToggleValue?.additionalJobsToggle || !elem?.MANDATORY && elem?.MANDATORYDefaultValue || jobCount?.AdditionalParts > 0}
                ,
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || (getTaskDetailsToggleValue === null || getTaskDetailsToggleValue === void 0 ? void 0 : getTaskDetailsToggleValue.additionalJobsToggle) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: JobCount === null || JobCount === void 0 || (_JobCount$data4 = JobCount.data) === null || _JobCount$data4 === void 0 ? void 0 : _JobCount$data4.AdditionalParts,
                countVisible: true,
                hideSwitch: true
            }, /*#__PURE__*/ React.createElement(RevisedEstimateAdditionalJobsComponent, {
                parentModuleName: EParentModuleName.RevisedServiceEstimate,
                saveAdditionalJobsUrl: '',
                callApIStatus: addiotionalJobApiCall,
                isSaveButton: true,
                isDisabled: false,
                additionalJobCallback: function () { },
                getDataFromChild: handleDataFromChild,
                alternatePartConfigState: alternatePartConfigState
            }))
                // <>Additional Jobs</>
                : null;
        })) : null;
    }) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        paddingTop: 25,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("No Data Found"), "..!!"))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: isDesktop ? '65vw' : '100%',
            height: '9vh',
            padding: "8px 8px 8px 8px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); }))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: isDesktop ? '65vw' : '100%',
            height: '9vh',
            padding: "8px 8px 8px 8px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '100%',
        spacing: 2,
        padding: 2,
        bgcolor: "#FFFFFF"
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiBorderBottom, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'row',
        spacing: 2,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "generate-estimate-btn",
        loading: loader.isLoaderOpen,
        variant: "contained",
        name: Module === isModuleConfig.Bajaj ? t('Next') : t('Generate estimate'),
        size: "medium",
        onClick: handleGenerateEstimate,
        disabled: IsbtnDisabled
    }))))));
};
export default AddNewJobs;
